import styled from "styled-components";
import colors from '../../../assets/styles/colors';

export const SaldoTotalRecoger = styled.div`
  margin-top: 8px;
  background: ${colors.bgFourthLight};
  border-radius: 8px;
  padding: 0px 5px 30px 0px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 30px;
  & > div {
    margin-top: 30px;
  }
`;

export const SaldoTotalRecogerContainer = styled.div`
  display: flex;
  align-self: flex-end;
  margin-right: 20px;  
  margin-left: 20px;
  flex-direction: column;
  margin-top: 6px;
  font-weight: 540;
  font-size: 18px;
  line-height: 24px;
  color: ${colors.white};
`;  

export const FinancesDataTotal = styled.div`
  margin-top: 8px;
  background: ${colors.bgPrimaryLight};
  border-radius: 8px;
  padding: 16px 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const FinancesDataTotalTitle = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: 23px;
  color: ${colors.white};
`;

export const FinancesDataTotalPrice = styled.span`
  margin-top: 6px;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0.03em;
  color: ${colors.white};
`;

export const FinancesDataFooter = styled.div`
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
`;

export const FinancesDataButtoCalculate = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${prop => prop.align ? 'space-between' : 'flex-end'};
  margin-top: 29px;
  margin-bottom: 23px;
`;

export const FinancesDataButtoCalculateButton = styled.button`
  align-items: center;
  padding: 8px 32px;
  background: ${colors.bgTertiary};
  border: 1px solid ${colors.bgTertiaryLight};
  box-shadow: 0px 5px 10px ${colors.shadow};
  border-radius: 48px;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.03em;
  font-weight: 700;
  font-family: 'Montserrat', sans-serif;
  transition: ease-in-out .2s;
  min-width: 158px;

  &:hover {
    background: ${colors.bgTertiaryHover};
    border: 1px solid ${colors.bgTertiaryHover};
    box-shadow: 0px 5px 15px ${colors.shadowHover};
  }
`;

export const FinancesDataCreditLine = styled.div`
  margin-top: 40px;
`;

export const FinancesDataCreditLineTitle = styled.h6`
  font-weight: 600;
  font-size: 17px;
  line-height: 21px;
  color: ${colors.textPrimary};
  letter-spacing: 0.03em;
`;

export const FinancesDataCreditCheckboxContainer = styled.div`
  display: flex;
  align-self: flex-end;
  margin-right: 20px;  
  flex-direction: column;
`;  

export const FinancesDataCreditCheckboxContainerLine = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 30px;
  & > div {
    margin-top: 30px;
  }
`;

export const FinancesDataCreditCheckboxContainerText = styled.div`  
  color: ${colors.textPrimary};
  margin-top: 15px;
`;

export const FinancesDataCreditCheckboxContainerTitle = styled.div`
  font-weight: bold;
`;

export const FinancesDataCreditCheckboxContainerSaldo = styled.div`
  box-shadow: 0px 8px 25px ${colors.shadow};
  border-radius: 8px;
  padding: 17px;
  align-items: center;
  display: flex;
`;

export const FinancesDataAddButton = styled.span`
  color: ${colors.bgSecondary};
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  cursor: pointer;
  text-decoration: underline;
`;

export const FinancesDataFieldContent = styled.div`
  margin-top: 30px;
`;

export const FinancesDataFieldTitle = styled.span`
  font-weight: 600;
  font-size: 17px;
  line-height: 21px;
  color: ${colors.textPrimary};
  margin-top: 28px;
  display: block;
`;

export const FinancesDataFieldInputTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const FinancesDataFieldTitleValorLabel = styled.label`
  color: ${colors.textPrimary};
  opacity: 0.9;
  font-size: 12px;
  line-height: 14px;
  text-transform: uppercase;
`;

export const FinancesDataFieldTitleValorDeleteItem = styled.span`
  cursor: pointer;
  color: ${colors.bgDanger};
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
`;

export const FinancesDataFieldContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 30px;
`;

export const FinancesDataTotalFieldsCredits = styled.div`
  width: 90%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${colors.textExGrayLight};
  border-radius: 8px;
  padding: 20px;
  margin: 40px auto 60px auto;
`;

export const FinancesDataTotalFieldsCreditsLabel = styled.span`
  color: ${colors.textPrimary};
  font-size: 16px;
  line-height: 23px;
  letter-spacing: 0.03em;
`;

export const FinancesDataTotalFieldsCreditsValue = styled.span`
  font-weight: 600;
  font-size: 17px;
  line-height: 21px;
  letter-spacing: 0.03em;
  color: ${colors.textPrimary};
  margin-left: 10px;
`;

export const FinancesDataNoCredit = styled.span`
  color: ${colors.bgDanger};
  display: block;
  margin-top: 5px;
  font-size: 16px;
`;